export type TailwindPalette = TailwindCommonPalette | TailwindExtraPalette;

export enum TailwindCommonPalette {
  TRANSPARENT = 'transparent',
  WHITE = 'white',
  BLACK = 'black',

  SLATE_50 = 'slate-50',
  SLATE_100 = 'slate-100',
  SLATE_200 = 'slate-200',
  SLATE_300 = 'slate-300',
  SLATE_400 = 'slate-400',
  SLATE_500 = 'slate-500',
  SLATE_600 = 'slate-600',
  SLATE_700 = 'slate-700',
  SLATE_800 = 'slate-800',
  SLATE_900 = 'slate-900',
  SLATE_950 = 'slate-950',

  GRAY_50 = 'gray-50',
  GRAY_100 = 'gray-100',
  GRAY_200 = 'gray-200',
  GRAY_300 = 'gray-300',
  GRAY_400 = 'gray-400',
  GRAY_500 = 'gray-500',
  GRAY_600 = 'gray-600',
  GRAY_700 = 'gray-700',
  GRAY_800 = 'gray-800',
  GRAY_900 = 'gray-900',
  GRAY_950 = 'gray-950',

  ZINC_50 = 'zinc-50',
  ZINC_100 = 'zinc-100',
  ZINC_200 = 'zinc-200',
  ZINC_300 = 'zinc-300',
  ZINC_400 = 'zinc-400',
  ZINC_500 = 'zinc-500',
  ZINC_600 = 'zinc-600',
  ZINC_700 = 'zinc-700',
  ZINC_800 = 'zinc-800',
  ZINC_900 = 'zinc-900',
  ZINC_950 = 'zinc-950',

  NEUTRAL_50 = 'neutral-50',
  NEUTRAL_100 = 'neutral-100',
  NEUTRAL_200 = 'neutral-200',
  NEUTRAL_300 = 'neutral-300',
  NEUTRAL_400 = 'neutral-400',
  NEUTRAL_500 = 'neutral-500',
  NEUTRAL_600 = 'neutral-600',
  NEUTRAL_700 = 'neutral-700',
  NEUTRAL_800 = 'neutral-800',
  NEUTRAL_900 = 'neutral-900',
  NEUTRAL_950 = 'neutral-950',

  RED_50 = 'red-50',
  RED_100 = 'red-100',
  RED_200 = 'red-200',
  RED_300 = 'red-300',
  RED_400 = 'red-400',
  RED_500 = 'red-500',
  RED_600 = 'red-600',
  RED_700 = 'red-700',
  RED_800 = 'red-800',
  RED_900 = 'red-900',
  RED_950 = 'red-950',

  ORANGE_50 = 'orange-50',
  ORANGE_100 = 'orange-100',
  ORANGE_200 = 'orange-200',
  ORANGE_300 = 'orange-300',
  ORANGE_400 = 'orange-400',
  ORANGE_500 = 'orange-500',
  ORANGE_600 = 'orange-600',
  ORANGE_700 = 'orange-700',
  ORANGE_800 = 'orange-800',
  ORANGE_900 = 'orange-900',
  ORANGE_950 = 'orange-950',

  AMBER_50 = 'amber-50',
  AMBER_100 = 'amber-100',
  AMBER_200 = 'amber-200',
  AMBER_300 = 'amber-300',
  AMBER_400 = 'amber-400',
  AMBER_500 = 'amber-500',
  AMBER_600 = 'amber-600',
  AMBER_700 = 'amber-700',
  AMBER_800 = 'amber-800',
  AMBER_900 = 'amber-900',
  AMBER_950 = 'amber-950',

  YELLOW_50 = 'yellow-50',
  YELLOW_100 = 'yellow-100',
  YELLOW_200 = 'yellow-200',
  YELLOW_300 = 'yellow-300',
  YELLOW_400 = 'yellow-400',
  YELLOW_500 = 'yellow-500',
  YELLOW_600 = 'yellow-600',
  YELLOW_700 = 'yellow-700',
  YELLOW_800 = 'yellow-800',
  YELLOW_900 = 'yellow-900',
  YELLOW_950 = 'yellow-950',

  LIME_50 = 'lime-50',
  LIME_100 = 'lime-100',
  LIME_200 = 'lime-200',
  LIME_300 = 'lime-300',
  LIME_400 = 'lime-400',
  LIME_500 = 'lime-500',
  LIME_600 = 'lime-600',
  LIME_700 = 'lime-700',
  LIME_800 = 'lime-800',
  LIME_900 = 'lime-900',
  LIME_950 = 'lime-950',

  GREEN_50 = 'green-50',
  GREEN_100 = 'green-100',
  GREEN_200 = 'green-200',
  GREEN_300 = 'green-300',
  GREEN_400 = 'green-400',
  GREEN_500 = 'green-500',
  GREEN_600 = 'green-600',
  GREEN_700 = 'green-700',
  GREEN_800 = 'green-800',
  GREEN_900 = 'green-900',
  GREEN_950 = 'green-950',

  EMERALD_50 = 'emerald-50',
  EMERALD_100 = 'emerald-100',
  EMERALD_200 = 'emerald-200',
  EMERALD_300 = 'emerald-300',
  EMERALD_400 = 'emerald-400',
  EMERALD_500 = 'emerald-500',
  EMERALD_600 = 'emerald-600',
  EMERALD_700 = 'emerald-700',
  EMERALD_800 = 'emerald-800',
  EMERALD_900 = 'emerald-900',
  EMERALD_950 = 'emerald-950',

  TEAL_50 = 'teal-50',
  TEAL_100 = 'teal-100',
  TEAL_200 = 'teal-200',
  TEAL_300 = 'teal-300',
  TEAL_400 = 'teal-400',
  TEAL_500 = 'teal-500',
  TEAL_600 = 'teal-600',
  TEAL_700 = 'teal-700',
  TEAL_800 = 'teal-800',
  TEAL_900 = 'teal-900',
  TEAL_950 = 'teal-950',

  CYAN_50 = 'cyan-50',
  CYAN_100 = 'cyan-100',
  CYAN_200 = 'cyan-200',
  CYAN_300 = 'cyan-300',
  CYAN_400 = 'cyan-400',
  CYAN_500 = 'cyan-500',
  CYAN_600 = 'cyan-600',
  CYAN_700 = 'cyan-700',
  CYAN_800 = 'cyan-800',
  CYAN_900 = 'cyan-900',
  CYAN_950 = 'cyan-950',

  SKY_50 = 'sky-50',
  SKY_100 = 'sky-100',
  SKY_200 = 'sky-200',
  SKY_300 = 'sky-300',
  SKY_400 = 'sky-400',
  SKY_500 = 'sky-500',
  SKY_600 = 'sky-600',
  SKY_700 = 'sky-700',
  SKY_800 = 'sky-800',
  SKY_900 = 'sky-900',
  SKY_950 = 'sky-950',

  BLUE_50 = 'blue-50',
  BLUE_100 = 'blue-100',
  BLUE_200 = 'blue-200',
  BLUE_300 = 'blue-300',
  BLUE_400 = 'blue-400',
  BLUE_500 = 'blue-500',
  BLUE_600 = 'blue-600',
  BLUE_700 = 'blue-700',
  BLUE_800 = 'blue-800',
  BLUE_900 = 'blue-900',
  BLUE_950 = 'blue-950',

  INDIGO_50 = 'indigo-50',
  INDIGO_100 = 'indigo-100',
  INDIGO_200 = 'indigo-200',
  INDIGO_300 = 'indigo-300',
  INDIGO_400 = 'indigo-400',
  INDIGO_500 = 'indigo-500',
  INDIGO_600 = 'indigo-600',
  INDIGO_700 = 'indigo-700',
  INDIGO_800 = 'indigo-800',
  INDIGO_900 = 'indigo-900',
  INDIGO_950 = 'indigo-950',

  PURPLE_50 = 'purple-50',
  PURPLE_100 = 'purple-100',
  PURPLE_200 = 'purple-200',
  PURPLE_300 = 'purple-300',
  PURPLE_400 = 'purple-400',
  PURPLE_500 = 'purple-500',
  PURPLE_600 = 'purple-600',
  PURPLE_700 = 'purple-700',
  PURPLE_800 = 'purple-800',
  PURPLE_900 = 'purple-900',
  PURPLE_950 = 'purple-950',

  FUCHSIA_50 = 'fuchsia-50',
  FUCHSIA_100 = 'fuchsia-100',
  FUCHSIA_200 = 'fuchsia-200',
  FUCHSIA_300 = 'fuchsia-300',
  FUCHSIA_400 = 'fuchsia-400',
  FUCHSIA_500 = 'fuchsia-500',
  FUCHSIA_600 = 'fuchsia-600',
  FUCHSIA_700 = 'fuchsia-700',
  FUCHSIA_800 = 'fuchsia-800',
  FUCHSIA_900 = 'fuchsia-900',
  FUCHSIA_950 = 'fuchsia-950',

  PINK_50 = 'pink-50',
  PINK_100 = 'pink-100',
  PINK_200 = 'pink-200',
  PINK_300 = 'pink-300',
  PINK_400 = 'pink-400',
  PINK_500 = 'pink-500',
  PINK_600 = 'pink-600',
  PINK_700 = 'pink-700',
  PINK_800 = 'pink-800',
  PINK_900 = 'pink-900',
  PINK_950 = 'pink-950',

  ROSE_50 = 'rose-50',
  ROSE_100 = 'rose-100',
  ROSE_200 = 'rose-200',
  ROSE_300 = 'rose-300',
  ROSE_400 = 'rose-400',
  ROSE_500 = 'rose-500',
  ROSE_600 = 'rose-600',
  ROSE_700 = 'rose-700',
  ROSE_800 = 'rose-800',
  ROSE_900 = 'rose-900',
  ROSE_950 = 'rose-950',
}

export enum TailwindExtraPalette {
  AMBER_500_25 = 'amber-500/25',

  BLACK_45 = 'black/45',

  SLATE_400_10 = 'slate-400/10',
  SLATE_400_25 = 'slate-400/25',

  WHITE = 'white',
  WHITE_25 = 'white/25',
  WHITE_50 = 'white/50',
  WHITE_75 = 'white/75',

  GRAY_200_20 = 'gray-200/20',
  GRAY_200_45 = 'gray-200/45',
  GRAY_200_50 = 'gray-200/50',
  GRAY_400_10 = 'gray-400/10',
  GRAY_500_45 = 'gray-500/45',

  NEUTRAL_200_70 = 'neutral-200/70',
  NEUTRAL_300_80 = 'neutral-300/80',
  NEUTRAL_800_50 = 'neutral-800/50',

  ZINC_400_50 = 'zinc-400/50',

  CYAN_50_25 = 'cyan-50/25',
  CYAN_50_75 = 'cyan-50/75',
  CYAN_300_25 = 'cyan-300/25',
  CYAN_950 = 'cyan-950',

  VIOLET_50 = 'violet-50',
  PURPLE_50 = 'purple-50',

  PINK_500_25 = 'pink-500/25',
  PINK_600_10 = 'pink-600/10',

  ORANGE_500_25 = 'orange-500/25',
  ORANGE_600_10 = 'orange-600/10',
  ORANGE_RADIAL = 'radial-gradient-orange',
}
